import React, { useEffect, useState } from 'react';
import { Box, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import Modal from '../../../components/Modal/Modal';
import { AppButton } from '../../../components/UI';
import { gomailFetch } from '../api';

const KEYS = [
  { name: 'serper_api_key', label: 'Serper', description: 'Recherche web utilisée pour vérifier les profils LinkedIn des candidats.' },
  { name: 'mistral_api_key', label: 'Mistral', description: "Modèle IA qui extrait et analyse le contenu des CV reçus." },
];

const ApiKeysModal = ({ open, onClose, snackbarShowMessage }) => {
  const [keys, setKeys] = useState({});
  const [values, setValues] = useState({});
  const [visible, setVisible] = useState({});
  const [saving, setSaving] = useState(null);

  useEffect(() => {
    if (open) gomailFetch('/api-keys').then((d) => setKeys(d || {})).catch(() => {});
  }, [open]);

  const save = async (name) => {
    const value = values[name]?.trim();
    if (!value) return;
    setSaving(name);
    try {
      const data = await gomailFetch(`/api-keys/${name}`, { method: 'PATCH', body: { value } });
      setKeys((p) => ({ ...p, ...data }));
      setValues((p) => ({ ...p, [name]: '' }));
      snackbarShowMessage?.('Clé mise à jour.', 'success');
    } catch (e) {
      snackbarShowMessage?.('Erreur lors de la mise à jour de la clé.', 'error');
    } finally {
      setSaving(null);
    }
  };

  const title = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box sx={{ width: 38, height: 38, borderRadius: '10px', bgcolor: '#ebf4fb', color: '#03407b', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <AdminPanelSettingsOutlinedIcon />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '1.05rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>Administration GoMail</Typography>
        <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>Clés API utilisées par l'analyse des CV.</Typography>
      </Box>
    </Box>
  );

  return (
    <Modal open={open} onClose={onClose} title={title} maxWidth="sm" actions={<AppButton variant="secondary" onClick={onClose}>Fermer</AppButton>}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {KEYS.map(({ name, label, description }) => {
          const info = keys[name];
          return (
            <Box key={name} sx={{ p: 2, border: '1px solid #e2e8f0', borderRadius: '12px' }}>
              <Typography sx={{ fontWeight: 800, color: '#0f172a', fontSize: '0.9rem' }}>{label}</Typography>
              <Typography sx={{ fontSize: '0.78rem', color: '#64748b' }}>{description}</Typography>
              <Typography sx={{ fontSize: '0.74rem', color: '#94a3b8', mt: 0.5 }}>
                Actuelle : <Box component="span" sx={{ fontFamily: 'monospace' }}>{info?.preview || '—'}</Box>
                {info?.updated_at && ` · mise à jour le ${String(info.updated_at).slice(0, 10)}`}
                {info?.updated_by && ` par ${info.updated_by}`}
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mt: 1.25 }}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Nouvelle clé…"
                  type={visible[name] ? 'text' : 'password'}
                  value={values[name] || ''}
                  onChange={(e) => setValues((p) => ({ ...p, [name]: e.target.value }))}
                  slotProps={{
                    input: {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton size="small" onClick={() => setVisible((p) => ({ ...p, [name]: !p[name] }))}>
                            {visible[name] ? <VisibilityOffOutlinedIcon fontSize="small" /> : <VisibilityOutlinedIcon fontSize="small" />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                <AppButton startIcon={<SaveOutlinedIcon />} loading={saving === name} disabled={!values[name]?.trim()} onClick={() => save(name)}>
                  Enregistrer
                </AppButton>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Modal>
  );
};

export default ApiKeysModal;
